

export const callAPI = async (url, options) =>{
    let headers;
    if (options?.data) {
      headers = { "Content-Type": "application/json" };
    } else {
      headers = "";
    }

    try{
        const raw = await fetch(url, {
            headers : {
                ...headers
            },
            method : options?.method || "GET",
            body: options?.data
                ? JSON.stringify(options?.data)
                : options?.form_data
                ? options?.form_data
                : undefined,
        });

        const data = await raw.json();

        if(!raw.ok){
            throw new Error(data.message);
        }
        return data;
    }catch(error){
        return error;
    }
}

export const POST_DATA_HEADEERS = {
    "Content-Type": "application/json"
  };